import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 12, viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.8805 0L5.72827 7.58517L2.28064 3.89512L0 6.0385L5.56982 12L16 2.30426L13.8805 0Z", fill: "black" }));
export default SvgCheck;
